import {useEffect, useRef} from 'react';
import Box from '@mui/material/Box';
import mapboxgl from 'mapbox-gl';

export default function LocatorMap( props ) {
    //console.debug("RTS Break LocatorMapSpatial");

    const map = useRef(null);

    useEffect(() => {
        if(map.current) return;

        map.current = new mapboxgl.Map({
            container: "mapContainer",
            accessToken: "pk.eyJ1IjoiamltcHRhayIsImEiOiJja3kzMXZyOHIwNnRvMnBwOGxrbWJ4ZDhiIn0.bWHzm3g7ZOvo1wcWf2w8fg",
            style: "mapbox://styles/mapbox/streets-v11",
            center: [-85.0716746, 33.5666694],
            zoom: 9
        });
    });

    
    useEffect(() => {
        if(!map.current) return;
        
        var maxLng = 0, maxLat = 0, minLng = 0, minLat = 0, markerCount = 0;

        props.data.map((ld, idx) => {
            if(ld.curLat != null && ld.curLng != null){
                const coord = {lat:ld.curLat, lng:ld.curLng};
                markerCount++;

                if (markerCount === 1) {
                    minLng = maxLng = ld.curLng // longitude
                    minLat = maxLat = ld.curLat; // latitude
                }
                else {
                    maxLng = ld.curLng > maxLng ? ld.curLng : maxLng;
                    minLng = ld.curLng < minLng ? ld.curLng : minLng;
                    maxLat = ld.curLat  > maxLat ? ld.curLat  : maxLat;
                    minLat = ld.curLat  < minLat ? ld.curLat  : minLat;
                }

                const elMarker = document.createElement('div');

                if(ld.curTrackerESN !== null){
                    elMarker.className = "rtsTrackerMarker";
                }
                else{
                    elMarker.className = "rtsMarker rtsDarkBackground";
                }
                const elNum = document.createElement('span');
                elNum.className = "rtsLightForeground";
                elNum.innerHTML = markerCount;
                elMarker.appendChild(elNum)

                let markerHTML = '<div><label style="font-size:1.5em; font-Weight:bold;">' + ld.reelSerialNumber + '</label></div>'
                + '<div><label>Product:</label><span>' + ld.curProductAlias + '</span></div>'  
                + '<div><label style="font-Weight:bold; padding-top:5px;">Location Information</span></div>'
                //+ '<div><label style="padding-left:5px;">Date & Time:</label><span>' + formatDate(ld.currentLocation.locTimeStamp) + '</span></div>'
                + '<div><label style="padding-left:5px;">Latitude:</label><span>' + ld.curLat + '</span></div>'
                + '<div><label style="padding-left:5px;">Longitude:</label><span>' + ld.curLng + '</span></div>';
                
                if(ld.curTrackerESN!==null){
                    markerHTML = markerHTML + '<div style="text-align:center; margin-top:10px;"><span style="font-weight:bold;">' + ld.curTrackerESN + '</span></div>';
                } 

                let marker = new mapboxgl.Marker(elMarker)
                    .setLngLat(coord)
                    .setPopup(new mapboxgl.Popup({offset: 30}).setHTML(markerHTML))
                    .addTo(map.current);

                return marker;
            }

            return null;
        });

        var sw = new mapboxgl.LngLat(minLng, minLat);
        var ne = new mapboxgl.LngLat(maxLng, maxLat);
        var llb = new mapboxgl.LngLatBounds(sw, ne);

        if(markerCount > 0){
            if(markerCount === 1){
                map.current.setCenter(sw);
            }
            else{
                map.current.fitBounds(llb,
                    {
                        padding: { top: 50, bottom: 50, left: 50, right: 50 } ,
                        animate: false
                    }
                );   
            }
        }     

    });  
    

    function formatDate(pDate){
        let dateParts = (pDate.split(/[T]/)[0]).split(/[-]/);
        const dateObject = dateParts[0].toString() + '-' + dateParts[1].toString() + '-' + dateParts[2].toString();
        return dateObject;
    }


    return(
        <Box id="mapContainer" style={{minHeight:"600px", maxHeight:"800px"}} ></Box>
    );
}
